export function toAPIDateFormat(date: Date): string {
  const month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1).toString();
  const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate().toString();
  return date.getFullYear() + '-' + month + '-' + day;
}

export function addMonths(date: Date, numberMonths: number): Date {
  return new Date(date.setMonth(date.getMonth() + numberMonths));
}
